/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Model, { attr } from '@ember-data/model';

export default class CurrentUsageModel extends Model {
  @attr('number') appId;
  @attr('number') value;
}
